import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col w-full py-5 gap-y-3"
}
const _hoisted_2 = { class: "flex items-center justify-center" }

import TextField from '@/components/Inputs/TextField.vue';
import { useSystemStore } from '@/store/system';
import { inject, onMounted, Ref } from 'vue';
import Spinner from '@/components/UI/Spinner.vue';
import { AlertModal } from '@/typings/modal';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useSystemStore();
const alertModal = inject('alertModal') as Ref<AlertModal>;

async function save() {
  await store.saveStatus();

  alertModal.value.show(
    'System status saved',
    'All logged in users will now see the new status.'
  );
}

onMounted(() => {
  store.getConfiguration();
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_unref(store).configuration)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Button, {
            label: "Save Changes",
            onClick: save
          })
        ]),
        _createVNode(TextField, {
          title: "Status",
          hint: "Will display to all logged in users",
          modelValue: _unref(store).configuration.SystemStatus,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).configuration.SystemStatus) = $event))
        }, null, 8, ["modelValue"])
      ]))
    : (_openBlock(), _createBlock(Spinner, { key: 1 }))
}
}

})